import { Checkbox, Field, FieldContainer, Validator } from '@cademy-ui/form';
import { FunctionComponent, useId, useMemo } from 'react';
import styles from './styles.module.scss';
import { TermsDialog } from '../../TermsDialog';
import { OriginString } from '@shared/types';
import { PublicEducator } from '@cademy-package/sdk-component-types';
import { LinkButton } from '../../../LinkButton';
import classNames from 'classnames';

export type TermsAndConditionsFieldProps = {
    name: string;
    educator: PublicEducator;
    origin: OriginString;
};

const onSubmitValidate: Validator<boolean> = (value) => {
    if (value !== true) {
        return {
            pass: false,
            message: 'Please accept the Terms and Conditions to continue',
        };
    }
    return { pass: true };
};

export const TermsAndConditionsField: FunctionComponent<TermsAndConditionsFieldProps> = ({
    name,
    educator,
    origin,
}) => {
    const id = useId();
    const hideTerms = useMemo(
        () => educator.feature_flags?.hide_terms && origin !== 'marketplace',
        [educator, origin]
    );

    return (
        <Field<boolean>
            name={name}
            initialValue={hideTerms}
            required={true}
            onSubmitValidate={onSubmitValidate}
        >
            {({ value, setValue, descriptionId, errorId, errors }) => {
                return (
                    <FieldContainer
                        className={classNames(styles.terms, hideTerms && styles.hidden)}
                        descriptionId={descriptionId}
                        errorId={errorId}
                        errors={errors}
                    >
                        <Checkbox id={id} isChecked={value || false} onChange={setValue} />
                        <label htmlFor={id}>
                            I accept the{' '}
                            <TermsDialog educator={educator} onAgree={() => setValue(true)}>
                                <LinkButton>Terms and Privacy Policy</LinkButton>
                            </TermsDialog>
                            ? <span className={styles.required}>*</span>
                        </label>
                    </FieldContainer>
                );
            }}
        </Field>
    );
};
